<template>
  <div>
  <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
    <div class="w-full mb-3 bg-red-100 border-red-400 border h-20">
      <draggable :list="nopearray" animation="200" group="small" tag="ul" class="p-4">
        <li v-for="(choice, index) in nopearray" class="inline-block mb-0 mx-1 overflow-hidden text-center bg-white rounded shadow w-24" :key="index">
            <span class="block align-middle cursor-move">
              <span class="align-middle text-xs">{{ choice.attributes['title'].text }}</span>
            </span>
        </li>
        <li v-if="!nopearray.length">{{ $t('Add a Pattern that is Not you here!') }}</li>
      </draggable>
    </div>
    <div class="comparison-wrapper py-3">
      <draggable :list="maybearray" animation="300" group="small" class="comparison-responsive">
          <!-- First Item -->
          <div v-for="(item, index) in maybearray" key="index" tag="div" class="comparison-item mb-1 mr-2 relative cursor-pointer" v-bind:class="{active: leftChosen}" >
            <div class="flex-grow h-full align-middle" v-on:click="(leftChosen = !leftChosen), (rightChosen = false)">
              <div class="attributes">
                <div v-if="!maybearray.length">{{ $t('Add a Pattern that is Maybe you here!') }}</div>
                  <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="attributes in item.attributes">
                    <span class="label container">{{ attributes.label }}</span>
                    <span class="description" v-html="attributes.text"></span>
                  </div>
              </div>
            </div>
          </div>
          <!-- Second Item -->
          <!-- <draggable :list="maybearray" animation="200" group="small" tag="div" v-for="(item, index) in maybearray" class="comparison-item mb-1 mr-2 relative cursor-pointer" v-bind:class="{active: rightChosen}">
            <div class="flex-grow h-full align-middle" v-on:click="(rightChosen = !rightChosen), (leftChosen = false)">
                <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                    <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="(attributes, index) in maybearray.attributes">
                        <span class="label container">{{ attributes.label }}</span>
                        <span class="description" v-html="attributes.text"></span>
                    </div>
                </div>
            </div>
            <div v-if="!maybearray.length">Add a Pattern that is Maybe you here!</div>
          </draggable> -->
      </draggable>
    </div>
    <div class="w-full mb-3 bg-green-100 border border-green-300 h-24">
      <draggable :list="maybearray" animation="200" group="small" tag="ul" class="p-4">
        <li v-for="(choice, index) in maybearray" class="inline-block mb-0 mx-1 overflow-hidden text-center bg-white rounded shadow w-24" :key="index">
            <span class="block align-middle cursor-move">
              <span class="align-middle text-xs">{{ choice.attributes['title'].text }}</span>
            </span>
        </li>
        <li v-if="!maybearray.length">{{ $t('Add a Pattern that is Maybe you here!') }}</li>
      </draggable>
    </div>
  </div>
  
      <div class="submit-button-wrapper">
        <transition name="fade" mode="in-out">
          <div v-if="leftChosen">
            <input type="hidden" name="submitLeft" :value="itemsarray[0].id">
            <button id="submitLeft" @click="submitLeft" type="submit" class="absolute px-5 py-2">{{ $t('Choose') }} {{ maybearray[0].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-5xl">forward</i></button>
          </div>
        </transition>
        <transition name="fade" mode="in-out">
          <div v-if="rightChosen">
            <input type="hidden" name="submitRight" :value="itemsarray[1].id">
            <button id="submitRight" @click="submitRight" type="submit" class="px-5 py-2">{{ $t('Choose') }} {{ maybearray[1].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-5xl">forward</i></button>
          </div>
        </transition>
      </div>
</div>
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
        components: {
          draggable
        },
        props: {
            array: '',
            route:'',
        },
        data() {
          return {
            leftChosen: false,
            rightChosen: false,
            itemsarray: this.array,
            maybearray: this.array,
            nopearray: [],
          }
        },
        methods: {
            submitLeft: function (event) {
              $( "#submitLeft").addClass( "loading" );
              axios.put(this.route, { 
                results: this.itemsarray[0].id 
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            },
            submitRight: function (event) {
              $( "#submitRight").addClass( "loading" );
              axios.put(this.route, { 
                results: [this.itemsarray[1].id]
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
